/**
 * The vendor portal's pages by name (ADMIN_USAGE.PAGES.<key>), from the route
 * a page view was recorded with — the longest prefix wins. A page added
 * later reads as its path until it gets a name here.
 */
export const VENDOR_PAGES: [string, string][] = [
  ['/home/dashboard', 'home'],
  ['/dashboard', 'home'],
  ['/home/chat', 'askArdi'],
  ['/home/agents', 'agents'],
  ['/home/channels', 'channels'],
  ['/home/routines', 'routines'],
  ['/home/overview', 'overview'],
  ['/home/integration', 'integration'],
  ['/home/billing', 'billing'],
  ['/home/team', 'team'],
  ['/home/devices', 'devices'],
  ['/home/notifications', 'notifications'],
  ['/products/new', 'newProduct'],
  ['/products/sync', 'productSync'],
  ['/products', 'catalog'],
  ['/visualizer/engagement/leads', 'leads'],
  ['/visualizer/engagement/analytics', 'visualizerAnalytics'],
  ['/visualizer/engagement/activity', 'visualizerActivity'],
  ['/visualizer/settings', 'visualizerSettings'],
  ['/visualizer/spaces', 'rooms'],
  ['/assistant/conversations', 'shopperConversations'],
  ['/assistant/questions', 'shopperQuestions'],
  ['/assistant/settings', 'assistantSettings'],
  ['/marketing/brand', 'brand'],
  ['/marketing/content-studio', 'contentStudio'],
  ['/marketing/email/compose', 'emailCompose'],
  ['/marketing/email/automation', 'emailAutomations'],
  ['/marketing/email', 'emailSettings'],
  ['/marketing/social-scheduler', 'social'],
  ['/ads/campaigns', 'adCampaigns'],
  ['/ads/suggestions', 'adSuggestions'],
  ['/ads/audiences', 'adAudiences'],
  ['/ads/budgets', 'adBudgets'],
  ['/ads/connections', 'adAccounts'],
  ['/ads', 'ads'],
  ['/business/visibility', 'visibility'],
  ['/business/competitors', 'competitors'],
  ['/business/sales', 'sales'],
];

/** The page's key in ADMIN_USAGE.PAGES, or null when it has no name yet. */
export function vendorPageKey(page: string): string | null {
  let best: [string, string] | null = null;
  for (const entry of VENDOR_PAGES) {
    const [prefix] = entry;
    if ((page === prefix || page.startsWith(`${prefix}/`)) && (!best || prefix.length > best[0].length)) best = entry;
  }
  return best ? best[1] : null;
}
